<template>
  <div>
    <b-loading :is-full-page="isFullPage" v-model="isLoading"> </b-loading>
    <nav class="submenu">
      <ul>
        <li
          v-for="(tab, index) of tabs"
          :key="index"
          :id="tab.id"
          :class="currentTab === index + 1 ? 'is-active' : ''"
        >
          <a @click="gotoStep(index + 1)">
            <b>{{ tab.name }}</b>
          </a>
        </li>
        <li class="ml-auto">
          <b-button
            size="is-small is-rounded"
            type="is-info"
            @click="openImportModal"
          >
            <b-icon icon="upload" class="mr-1"></b-icon>
            Import Excel
          </b-button>
        </li>
      </ul>
    </nav>
    <div class="content-page pt-6">
      <section id="teacher" v-if="step == 1">
        <div class="frowho mt-0 mb-6">
          <b-icon icon="user" type="is-primary"></b-icon>
          <div class="is-flex justify-content-between align-items-center w-100">
            <div>
              <div class="title">Associez des formateurs à cette formation</div>
              <div class="subtitle">
                Vous pouvez sélectionner et ajouter plusieurs utilisateurs dans
                le menu déroulant.
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-tablet">
          <div class="column is-4">
            <b-field label="Rechercher par mot clé (nom, prénom, email, rôle)">
              <b-input
                placeholder="Rechercher..."
                type="search"
                icon="magnify"
                icon-clickable
                @icon-click="setAvailableTeachers()"
                v-model="search"
                @keydown.enter.native="setAvailableTeachers()"
                @input="setAvailableTeachers()"
              >
              </b-input>
            </b-field>
            <b-message type="is-warning" v-if="!availableteachers.length && !search">
              Rechercher un formateur
            </b-message>
            <b-message type="is-warning" v-else>
              {{ availableteachers.length }} formateur(s) disponibles
            </b-message>
            <b-table
              v-if="availableteachers.length"
              class="table_simple table_users"
              :data="availableteachers"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
              :checked-rows.sync="teachers"
              checkable
              paginated
              :per-page="perPage"
            >
              <b-table-column
                field="user"
                label="Nom"
                width="40"
                v-slot="props"
              >
                <b>
                  {{ props.row.last_name }}
                  {{ props.row.first_name }}
                </b>
              </b-table-column>
            </b-table>
            <b-button
              class="mt-4"
              @click.prevent="addTeachers"
              v-if="availableteachers.length"
              type="is-primary"
              rounded
              :disabled="!teachers.length"
              >Ajouter des formateurs</b-button
            >
          </div>
          <div class="column" v-if="training.teachers">
            <div class="is-flex justify-content-between align-items-center mb-3">
              <b>Formateurs associés à la formation</b>
              <b-button size="is-small is-rounded" type="is-primary" @click="openCreateTeacherModal">
                <b-icon icon="user" class="mr-1"></b-icon>
                Créer
              </b-button>
            </div>
            <div class="is-flex mt-2">
              <div class="has-text-primary mr-2">
                Ont-ils le droit de modifier la formation ?
              </div>
              <b-field>
                <b-switch
                  v-model="training.teachers_can_edit"
                  type="is-success"
                  @input="teacherEdition"
                >
                  {{
                    training.teachers_can_edit
                      ? "Droits de modification"
                      : "Droits de lecture"
                  }}
                </b-switch>
              </b-field>
            </div>
            <b-table
              v-if="training.teachers.length"
              class="table_simple table_users"
              :data="training.teachers"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
            >
              <template v-for="column in usersColumns">
                <b-table-column :key="column.id" v-bind="column">
                  <template v-slot="props" v-if="column.field === 'user'">
                    <div class="is-flex align-items-center">
                      <b>{{ getTeacherNameById(props.row) }}</b>
                    </div>
                  </template>
                  <template
                    v-slot="props"
                    v-else-if="column.field === 'delete'"
                  >
                    {{ props.row.student_id }}
                    <div @click.prevent="removeTeacher(props.row)">
                      <b-icon icon="close" type="is-danger"></b-icon>
                    </div>
                  </template>
                </b-table-column>
              </template>
            </b-table>
            <b-message v-else type="is-info" size="is-small"
              >Aucune personne n'a été associée comme formateur.</b-message
            >
          </div>
          <b-modal :active.sync="newTeacherModalActive" has-modal-card>
            <div class="modal-card">
              <header class="modal-card-head">
                <p class="modal-card-title">Créer un formateur</p>
                <button class="delete" aria-label="close" @click="closeCreateTeacherModal"></button>
              </header>
              <section class="modal-card-body">
                <b-field label="Nom" required>
                  <b-input v-model="newTeacherLastName"></b-input>
                </b-field>
                <b-field label="Prénom" required>
                  <b-input v-model="newTeacherFirstName"></b-input>
                </b-field>
                <b-field label="Email" required>
                  <b-input type="email" v-model="newTeacherEmail"></b-input>
                </b-field>
                <b-field label="Identifiant">
                  <b-input v-model="newTeacherIdentifier"></b-input>
                </b-field>
                <b-field>
                  <b-checkbox v-model="newTeacherAssociateToTraining">
                    Associer à la formation
                  </b-checkbox>
                </b-field>
              </section>
              <footer class="modal-card-foot">
                <b-button type="is-primary" @click="submitCreateTeacher">Créer</b-button>
                <b-button @click="closeCreateTeacherModal">Annuler</b-button>
              </footer>
            </div>
          </b-modal>
        </div>
      </section>
      <section id="students" v-if="step == 2">
        <div class="frowho mt-0 mb-6">
          <b-icon icon="user" type="is-primary"></b-icon>
          <div class="is-flex justify-content-between align-items-center w-100">
            <div>
              <div class="title">Associez des apprenants à cette formation</div>
              <div class="subtitle">
                Vous pouvez sélectionner et ajouter plusieurs utilisateurs dans
                le menu déroulant. Vous leur attribuerez des mangers et tuteurs
                plus tard.
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-tablet">
          <div class="column is-4">
            <b-field label="Rechercher par mot clé (nom, prénom, email, rôle)">
              <b-input
                placeholder="Rechercher..."
                type="search"
                icon="magnify"
                icon-clickable
                @icon-click="setAvailableStudents()"
                v-model="search"
                @keydown.enter.native="setAvailableStudents()"
              >
              </b-input>
            </b-field>
            <b-message type="is-warning" v-if="!availablestudents.length && !search">
              Rechercher un apprenant
            </b-message>
            <b-message type="is-warning" v-else>
              {{ availablestudents.length }} apprenant(s) disponibles
            </b-message>
            <b-table
              v-if="availablestudents.length"
              class="table_simple table_users"
              :data="availablestudents"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
              :checked-rows.sync="students"
              checkable
              paginated
              :per-page="perPage"
            >
              <b-table-column
                field="user"
                label="Nom"
                width="40"
                v-slot="props"
              >
                <b>
                  {{ props.row.last_name }}
                  {{ props.row.first_name }}
                </b>
              </b-table-column>
            </b-table>
            <b-button
              class="mt-4"
              @click.prevent="addStudents"
              v-if="availablestudents.length"
              type="is-primary"
              rounded
              :disabled="!students.length"
              >Ajouter des apprenants</b-button
            >
          </div>
          <div class="column">
            <div class="is-flex justify-content-between align-items-center mb-3">
              <b>Apprenants associés à la formation</b>
              <div>
                <b-button size="is-small is-rounded" type="is-primary" class="mr-2" @click="openCreateStudentModal">
                  <b-icon icon="user" class="mr-1"></b-icon>
                  Créer
                </b-button>
                <b-button size="is-small is-rounded" type="is-info" @click="openImportModal">
                  <b-icon icon="upload" class="mr-1"></b-icon>
                  Import Excel
                </b-button>
              </div>
            </div>
            <b-table
              v-if="training.students.length"
              class="table_simple table_users"
              :data="training.students"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
              paginated
              :per-page="perPage"
            >
              <template v-for="column in usersColumns">
                <b-table-column :key="column.id" v-bind="column">
                  <template v-slot="props" v-if="column.field === 'user'">
                    <b>{{ getStudentNameById(props.row) }}</b>
                  </template>
                  <template
                    v-slot="props"
                    v-else-if="column.field === 'delete'"
                  >
                    {{ props.row.student_id }}
                    <div @click.prevent="removeStudent(props.row)">
                      <b-icon icon="close" type="is-danger"></b-icon>
                    </div>
                  </template>
                </b-table-column>
              </template>
            </b-table>
            <b-message class="mt-3" v-else type="is-info" size="is-small"
              >Aucune personne n'a été associée comme apprenant.</b-message
            >
          </div>
        </div>
      </section>
      <section id="managers" v-if="step == 3">
        <div class="frowho mt-0 mb-6">
          <b-icon icon="user" type="is-primary"></b-icon>
          <div class="is-flex justify-content-between align-items-center w-100">
            <div>
              <div class="title">Associez des managers à cette formation</div>
              <div class="subtitle">
                Vous pouvez sélectionner et ajouter plusieurs utilisateurs dans
                le menu déroulant.
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-tablet">
          <div class="column is-4">
            <b-field label="Rechercher par mot clé (nom, prénom, email, rôle)">
              <b-input
                placeholder="Rechercher..."
                type="search"
                icon="magnify"
                icon-clickable
                @icon-click="setAvailableManagers()"
                v-model="search"
                @keydown.enter.native="setAvailableManagers()"
                @input="setAvailableManagers()"
              >
              </b-input>
            </b-field>
            <b-message type="is-warning" v-if="!availablemanagers.length && !search">
              Rechercher un manager
            </b-message>
            <b-message type="is-warning" v-else>
              {{ availablemanagers.length }} manager(s) disponibles
            </b-message>
            <b-table
              v-if="availablemanagers.length"
              class="table_simple table_users"
              :data="availablemanagers"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
              :checked-rows.sync="managers"
              checkable
            >
              <b-table-column
                field="user"
                label="Nom"
                width="40"
                v-slot="props"
              >
                <b>
                  {{ props.row.last_name }}
                  {{ props.row.first_name }}
                </b>
              </b-table-column>
            </b-table>
            <b-button
              class="mt-4"
              @click.prevent="addManagers"
              v-if="availablemanagers.length"
              type="is-primary"
              rounded
              :disabled="!managers.length"
              >Ajouter des managers</b-button
            >
          </div>
          <div class="column">
            <div class="is-flex justify-content-between align-items-center mb-3">
              <b>Managers associés à la formation</b>
              <b-button size="is-small is-rounded" type="is-primary" @click="openCreateManagerModal">
                <b-icon icon="user" class="mr-1"></b-icon>
                Créer
              </b-button>
            </div>
            <b-table
              v-if="training.managers.length"
              class="table_simple table_users"
              :data="training.managers"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
            >
              <template v-for="column in usersColumns">
                <b-table-column :key="column.id" v-bind="column">
                  <template v-slot="props" v-if="column.field === 'user'">
                    <b>{{ getManagerNameById(props.row) }}</b>
                  </template>
                  <template
                    v-slot="props"
                    v-else-if="column.field === 'delete'"
                  >
                    {{ props.row.student_id }}
                    <div @click.prevent="removeManager(props.row)">
                      <b-icon icon="close" type="is-danger"></b-icon>
                    </div>
                  </template>
                </b-table-column>
              </template>
            </b-table>
            <b-message class="mt-3" v-else type="is-info" size="is-small"
              >Aucune personne n'a été associée comme manager.</b-message
            >
          </div>
        </div>
      </section>
      <section id="tutors" v-if="step == 4">
        <div class="frowho mt-0 mb-6">
          <b-icon icon="user" type="is-primary"></b-icon>
          <div class="is-flex justify-content-between align-items-center w-100">
            <div>
              <div class="title">Associez des tuteurs à cette formation</div>
              <div class="subtitle">
                Vous pouvez sélectionner et ajouter plusieurs utilisateurs dans
                le menu déroulant.
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-tablet">
          <div class="column is-4">
            <b-field label="Rechercher par mot clé (nom, prénom, email, rôle)">
              <b-input
                placeholder="Rechercher..."
                type="search"
                icon="magnify"
                icon-clickable
                @icon-click="setAvailableTutors()"
                v-model="search"
                @keydown.enter.native="setAvailableTutors()"
                @input="setAvailableTutors()"
              >
              </b-input>
            </b-field>
            <b-message type="is-warning" v-if="!availabletutors.length && !search">
              Rechercher un tuteur
            </b-message>
            <b-message type="is-warning" v-else>
              {{ availabletutors.length }} tuteur(s) disponibles
            </b-message>
            <b-table
              v-if="availabletutors.length"
              class="table_simple table_users"
              :data="availabletutors"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
              :checked-rows.sync="tutors"
              checkable
            >
              <b-table-column
                field="user"
                label="Nom"
                width="40"
                v-slot="props"
              >
                <b>
                  {{ props.row.last_name }}
                  {{ props.row.first_name }}
                </b>
              </b-table-column>
            </b-table>
            <b-button
              class="mt-4"
              @click.prevent="addTutors"
              v-if="availabletutors.length"
              type="is-primary"
              rounded
              :disabled="!tutors.length"
              >Ajouter des tuteurs</b-button
            >
          </div>
          <div class="column">
            <div class="is-flex justify-content-between align-items-center mb-3">
              <b>Tuteurs associés à la formation</b>
              <b-button size="is-small is-rounded" type="is-primary" @click="openCreateTutorModal">
                <b-icon icon="user" class="mr-1"></b-icon>
                Créer
              </b-button>
            </div>
            <b-table
              v-if="training.tutors.length"
              class="table_simple table_users"
              :data="training.tutors"
              ref="table"
              :debounce-search="1000"
              default-sort="name"
            >
              <template v-for="column in usersColumns">
                <b-table-column :key="column.id" v-bind="column">
                  <template v-slot="props" v-if="column.field === 'user'">
                    <b>{{ getTutorNameById(props.row) }}</b>
                  </template>
                  <template
                    v-slot="props"
                    v-else-if="column.field === 'delete'"
                  >
                    {{ props.row.student_id }}
                    <div @click.prevent="removeTutor(props.row)">
                      <b-icon icon="close" type="is-danger"></b-icon>
                    </div>
                  </template>
                </b-table-column>
              </template>
            </b-table>
            <b-message class="mt-3" v-else type="is-info" size="is-small"
              >Aucune personne n'a été associée comme tuteur.</b-message
            >
          </div>
        </div>
      </section>
      <b-modal :active.sync="newStudentModalActive" has-modal-card>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Créer un apprenant</p>
            <button class="delete" aria-label="close" @click="closeCreateStudentModal"></button>
          </header>
          <section class="modal-card-body">
            <b-message type="is-warning" class="mb-4">
              ⚠ La création d'un parcours apprenant entraîne <i>de facto</i> sa prise en compte dans la facturation.
            </b-message>
            <b-field label="Nom" required>
              <b-input v-model="newStudentLastName"></b-input>
            </b-field>
            <b-field label="Prénom" required>
              <b-input v-model="newStudentFirstName"></b-input>
            </b-field>
            <b-field label="Email" required>
              <b-input type="email" v-model="newStudentEmail"></b-input>
            </b-field>
            <b-field label="Entreprise">
              <b-input v-model="newStudentEnterprise"></b-input>
            </b-field>
            <b-field label="Identifiant">
              <b-input v-model="newStudentIdentifier"></b-input>
            </b-field>
            <b-field>
              <b-checkbox v-model="newStudentAssociateToTraining">
                Associer à la formation
              </b-checkbox>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button type="is-primary" @click="submitCreateStudent">Créer</b-button>
            <b-button @click="closeCreateStudentModal">Annuler</b-button>
          </footer>
        </div>
      </b-modal>
      <b-modal :active.sync="importModalActive" has-modal-card>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Import Excel d'apprenants, tuteurs, formateurs</p>
            <button class="delete" aria-label="close" @click="closeImportModal"></button>
          </header>
          <section class="modal-card-body">
            <b-message type="is-info" class="mb-4">
              Utilisez le modèle d'import fourni (fichier Excel) puis importez-le ici.
              <br />
              <a href="/examples/import_utilisateurs.xlsx" download>
                Télécharger le modèle d'import des utilisateurs
              </a>
            </b-message>
            <b-field label="Fichier Excel (.xlsx)">
              <input
                class="input"
                type="file"
                accept=".xlsx,.xls"
                @change="onImportFileChange"
              />
            </b-field>
            <b-message v-if="importError" type="is-danger">{{ importError }}</b-message>
          </section>
          <footer class="modal-card-foot">
            <b-button
              type="is-primary"
              :disabled="!importFile || importInProgress"
              @click="submitImportExcel"
            >
              Importer
            </b-button>
            <b-button @click="closeImportModal">Annuler</b-button>
          </footer>
        </div>
      </b-modal>
      <b-modal :active.sync="newManagerModalActive" has-modal-card>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Créer un manager</p>
            <button class="delete" aria-label="close" @click="closeCreateManagerModal"></button>
          </header>
          <section class="modal-card-body">
            <b-field label="Nom" required>
              <b-input v-model="newManagerLastName"></b-input>
            </b-field>
            <b-field label="Prénom" required>
              <b-input v-model="newManagerFirstName"></b-input>
            </b-field>
            <b-field label="Email" required>
              <b-input type="email" v-model="newManagerEmail"></b-input>
            </b-field>
            <b-field label="Entreprise">
              <b-input v-model="newManagerEnterprise"></b-input>
            </b-field>
            <b-field label="Identifiant">
              <b-input v-model="newManagerIdentifier"></b-input>
            </b-field>
            <b-field>
              <b-checkbox v-model="newManagerAssociateToTraining">
                Associer à la formation
              </b-checkbox>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button type="is-primary" @click="submitCreateManager">Créer</b-button>
            <b-button @click="closeCreateManagerModal">Annuler</b-button>
          </footer>
        </div>
      </b-modal>
      <b-modal :active.sync="newTutorModalActive" has-modal-card>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Créer un tuteur</p>
            <button class="delete" aria-label="close" @click="closeCreateTutorModal"></button>
          </header>
          <section class="modal-card-body">
            <b-field label="Nom" required>
              <b-input v-model="newTutorLastName"></b-input>
            </b-field>
            <b-field label="Prénom" required>
              <b-input v-model="newTutorFirstName"></b-input>
            </b-field>
            <b-field label="Email" required>
              <b-input type="email" v-model="newTutorEmail"></b-input>
            </b-field>
            <b-field label="Entreprise">
              <b-input v-model="newTutorEnterprise"></b-input>
            </b-field>
            <b-field label="Identifiant">
              <b-input v-model="newTutorIdentifier"></b-input>
            </b-field>
            <b-field>
              <b-checkbox v-model="newTutorAssociateToTraining">
                Associer à la formation
              </b-checkbox>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button type="is-primary" @click="submitCreateTutor">Créer</b-button>
            <b-button @click="closeCreateTutorModal">Annuler</b-button>
          </footer>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import * as XLSX from 'xlsx';

export default {
  computed: {
    ...mapState('auth', ['currentUser']),
  },
  methods: {
    openCreateTeacherModal() {
      this.newTeacherModalActive = true;
      this.newTeacherLastName = '';
      this.newTeacherFirstName = '';
      this.newTeacherEmail = '';
      this.newTeacherIdentifier = '';
      this.newTeacherAssociateToTraining = true;
    },
    closeCreateTeacherModal() {
      this.newTeacherModalActive = false;
    },
    openImportModal() {
      this.importModalActive = true;
      this.importFile = null;
      this.importError = null;
    },
    closeImportModal() {
      this.importModalActive = false;
      this.importFile = null;
      this.importError = null;
      this.importInProgress = false;
    },
    onImportFileChange(event) {
      const files = event.target.files || (event.dataTransfer && event.dataTransfer.files);
      if (!files || !files.length) {
        this.importFile = null;
        return;
      }
      this.importFile = files[0];
      this.importError = null;
    },
    submitImportExcel() {
      if (!this.importFile) {
        this.importError = 'Veuillez sélectionner un fichier Excel.';
        return;
      }
      this.importInProgress = true;
      this.importError = null;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          if (!rows || rows.length < 2) {
            this.importError = 'Le fichier ne contient aucune donnée.';
            this.importInProgress = false;
            return;
          }
          const payload = {
            training: this.training.id || this.$route.params.idTraining,
          };
          // On suppose que la première ligne contient les en-têtes dans l'ordre attendu
          // et que les données commencent à la ligne 2.
          for (let i = 1; i < rows.length; i += 1) {
            const row = rows[i];
            if (!row || row.length === 0) {
              // ignorer les lignes vides
              continue;
            }
            const idx = i; // index de ligne pour suffixer les champs
            const [
              nomApprenant,
              prenomApprenant,
              emailApprenant,
              usernameApprenant,
              nomTuteur,
              prenomTuteur,
              emailTuteur,
              entreprise,
              nomFormateur,
              prenomFormateur,
              emailFormateur,
            ] = row;

            payload[`email_apprenant_${idx}`] = emailApprenant || '';
            payload[`prenom_apprenant_${idx}`] = prenomApprenant || '';
            payload[`nom_apprenant_${idx}`] = nomApprenant || '';
            payload[`username_apprenant_${idx}`] = usernameApprenant || '';
            payload[`nom_tuteur_${idx}`] = nomTuteur || '';
            payload[`prenom_tuteur_${idx}`] = prenomTuteur || '';
            payload[`email_tuteur_${idx}`] = emailTuteur || '';
            payload[`entreprise_${idx}`] = entreprise || '';
            payload[`nom_formateur_${idx}`] = nomFormateur || '';
            payload[`prenom_formateur_${idx}`] = prenomFormateur || '';
            payload[`email_formateur_${idx}`] = emailFormateur || '';
          }

          this.startLoading();
          this.$http.post('/manage/inscriptions_manuelles', payload)
            .then(() => {
              this.$buefy.notification.open({
                message: 'Import Excel traité avec succès',
                type: 'is-success',
              });
              // recharger les apprenants de la formation
              this.initTraining();
            })
            .catch(() => {
              this.importError = 'Erreur lors de l\'envoi des données au serveur.';
            })
            .finally(() => {
              this.importInProgress = false;
              this.endLoading();
              if (!this.importError) {
                this.closeImportModal();
              }
            });
        } catch (err) {
          this.importError = 'Erreur lors de la lecture du fichier Excel.';
          this.importInProgress = false;
        }
      };
      reader.onerror = () => {
        this.importError = 'Impossible de lire le fichier sélectionné.';
        this.importInProgress = false;
      };
      reader.readAsArrayBuffer(this.importFile);
    },
    openCreateStudentModal() {
      this.newStudentModalActive = true;
      this.newStudentLastName = '';
      this.newStudentFirstName = '';
      this.newStudentEmail = '';
      this.newStudentIdentifier = '';
      this.newStudentAssociateToTraining = true;
      this.newStudentEnterprise = '';
    },
    closeCreateStudentModal() {
      this.newStudentModalActive = false;
    },
    openCreateManagerModal() {
      this.newManagerModalActive = true;
      this.newManagerLastName = '';
      this.newManagerFirstName = '';
      this.newManagerEmail = '';
      this.newManagerIdentifier = '';
      this.newManagerAssociateToTraining = true;
      this.newManagerEnterprise = '';
    },
    closeCreateManagerModal() {
      this.newManagerModalActive = false;
    },
    openCreateTutorModal() {
      this.newTutorModalActive = true;
      this.newTutorLastName = '';
      this.newTutorFirstName = '';
      this.newTutorEmail = '';
      this.newTutorIdentifier = '';
      this.newTutorAssociateToTraining = true;
      this.newTutorEnterprise = '';
    },
    closeCreateTutorModal() {
      this.newTutorModalActive = false;
    },
    submitCreateTeacher() {
      if (!this.newTeacherLastName || !this.newTeacherFirstName || !this.newTeacherEmail) {
        this.$buefy.toast.open({
          message: 'Nom, prénom et email sont obligatoires.',
          type: 'is-danger',
        });
        return;
      }
      const cfaId = this.currentUser && this.currentUser.cfa_id ? this.currentUser.cfa_id : undefined;
      const orgId = this.currentUser && this.currentUser.organization_id ? this.currentUser.organization_id : undefined;
      let username = '';
      if (this.newTeacherIdentifier) {
        username = this.newTeacherIdentifier;
      } else if (this.newTeacherEmail && this.newTeacherEmail.includes('@')) {
        username = this.newTeacherEmail.split('@')[0];
      } else {
        username = `${this.newTeacherFirstName}.${this.newTeacherLastName}`.toLowerCase();
      }
      const payload = {
        data: [
          {
            last_name: this.newTeacherLastName,
            first_name: this.newTeacherFirstName,
            email: this.newTeacherEmail,
            email2: '',
            email3: '',
            username,
            ypareo_id: '',
            azure_id: '',
            role: 'formateur',
            cfa: cfaId,
            organization: orgId,
            training: this.newTeacherAssociateToTraining && this.training
              ? this.training.id
              : undefined,
          },
        ],
      };
      this.startLoading();
      this.$http.post('/create_users/', payload)
        .then((response) => {
          const createdId = response.data && response.data.id;
          if (createdId && this.newTeacherAssociateToTraining) {
            const teacherToPatch = [...this.training.teachers, createdId];
            return this.$http.patch(`/trainings/${this.$route.params.idTraining}/`, {
              teachers: teacherToPatch,
            }).then((res2) => {
              this.training = res2.data;
              this.teachersList.push({ id: createdId, name: `${this.newTeacherLastName} ${this.newTeacherFirstName}` });
            });
          }
          if (createdId) {
            this.teachersList.push({ id: createdId, name: `${this.newTeacherLastName} ${this.newTeacherFirstName}` });
          }
          return null;
        })
        .then(() => {
          this.$buefy.notification.open({
            message: 'Formateur créé',
            type: 'is-success',
          });
          this.initTraining();
        })
        .catch(() => {
          this.$buefy.notification.open({
            message: 'Erreur lors de la création du formateur',
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.endLoading();
          this.closeCreateTeacherModal();
        });
    },
    submitCreateStudent() {
      if (!this.newStudentLastName || !this.newStudentFirstName || !this.newStudentEmail) {
        this.$buefy.toast.open({
          message: 'Nom, prénom et email sont obligatoires.',
          type: 'is-danger',
        });
        return;
      }
      const cfaId = this.currentUser && this.currentUser.cfa_id ? this.currentUser.cfa_id : undefined;
      const orgId = this.currentUser && this.currentUser.organization_id ? this.currentUser.organization_id : undefined;
      let username = '';
      if (this.newStudentIdentifier) {
        username = this.newStudentIdentifier;
      } else if (this.newStudentEmail && this.newStudentEmail.includes('@')) {
        username = this.newStudentEmail.split('@')[0];
      } else {
        username = `${this.newStudentFirstName}.${this.newStudentLastName}`.toLowerCase();
      }
      const payload = {
        data: [
          {
            last_name: this.newStudentLastName,
            first_name: this.newStudentFirstName,
            email: this.newStudentEmail,
            email2: '',
            email3: '',
            username,
            ypareo_id: '',
            azure_id: '',
            enterprise: this.newStudentEnterprise || '',
            role: 'apprenant',
            cfa: cfaId,
            organization: orgId,
            training: this.newStudentAssociateToTraining && this.training
              ? this.training.id
              : undefined,
          },
        ],
      };
      this.startLoading();
      this.$http.post('/create_users/', payload)
        .then((response) => {
          const createdId = response.data && response.data.id;
          if (createdId && this.newStudentAssociateToTraining) {
            const studentsToPatch = [...this.training.students, createdId];
            return this.$http.patch(`/trainings/${this.$route.params.idTraining}/`, {
              students: studentsToPatch,
            }).then((res2) => {
              this.training = res2.data;
              this.studentsList.push({ id: createdId, name: `${this.newStudentLastName} ${this.newStudentFirstName}` });
            });
          }
          if (createdId) {
            this.studentsList.push({ id: createdId, name: `${this.newStudentLastName} ${this.newStudentFirstName}` });
          }
          return null;
        })
        .then(() => {
          this.$buefy.notification.open({
            message: 'Apprenant créé',
            type: 'is-success',
          });
          this.initTraining();
        })
        .catch(() => {
          this.$buefy.notification.open({
            message: 'Erreur lors de la création de l’apprenant',
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.endLoading();
          this.closeCreateStudentModal();
        });
    },
    submitCreateManager() {
      if (!this.newManagerLastName || !this.newManagerFirstName || !this.newManagerEmail) {
        this.$buefy.toast.open({
          message: 'Nom, prénom et email sont obligatoires.',
          type: 'is-danger',
        });
        return;
      }
      const cfaId = this.currentUser && this.currentUser.cfa_id ? this.currentUser.cfa_id : undefined;
      const orgId = this.currentUser && this.currentUser.organization_id ? this.currentUser.organization_id : undefined;
      let username = '';
      if (this.newManagerIdentifier) {
        username = this.newManagerIdentifier;
      } else if (this.newManagerEmail && this.newManagerEmail.includes('@')) {
        username = this.newManagerEmail.split('@')[0];
      } else {
        username = `${this.newManagerFirstName}.${this.newManagerLastName}`.toLowerCase();
      }
      const payload = {
        data: [
          {
            last_name: this.newManagerLastName,
            first_name: this.newManagerFirstName,
            email: this.newManagerEmail,
            email2: '',
            email3: '',
            username,
            ypareo_id: '',
            azure_id: '',
            enterprise: this.newManagerEnterprise || '',
            role: 'manager',
            cfa: cfaId,
            organization: orgId,
            training: this.newManagerAssociateToTraining && this.training
              ? this.training.id
              : undefined,
          },
        ],
      };
      this.startLoading();
      this.$http.post('/create_users/', payload)
        .then((response) => {
          const createdId = response.data && response.data.id;
          if (createdId && this.newManagerAssociateToTraining) {
            const managersToPatch = [...this.training.managers, createdId];
            return this.$http.patch(`/trainings/${this.$route.params.idTraining}/`, {
              managers: managersToPatch,
            }).then((res2) => {
              this.training = res2.data;
              this.managersList.push({ id: createdId, name: `${this.newManagerLastName} ${this.newManagerFirstName}` });
            });
          }
          if (createdId) {
            this.managersList.push({ id: createdId, name: `${this.newManagerLastName} ${this.newManagerFirstName}` });
          }
          return null;
        })
        .then(() => {
          this.$buefy.notification.open({
            message: 'Manager créé',
            type: 'is-success',
          });
          this.initTraining();
        })
        .catch(() => {
          this.$buefy.notification.open({
            message: 'Erreur lors de la création du manager',
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.endLoading();
          this.closeCreateManagerModal();
        });
    },
    submitCreateTutor() {
      if (!this.newTutorLastName || !this.newTutorFirstName || !this.newTutorEmail) {
        this.$buefy.toast.open({
          message: 'Nom, prénom et email sont obligatoires.',
          type: 'is-danger',
        });
        return;
      }
      const cfaId = this.currentUser && this.currentUser.cfa_id ? this.currentUser.cfa_id : undefined;
      const orgId = this.currentUser && this.currentUser.organization_id ? this.currentUser.organization_id : undefined;
      let username = '';
      if (this.newTutorIdentifier) {
        username = this.newTutorIdentifier;
      } else if (this.newTutorEmail && this.newTutorEmail.includes('@')) {
        username = this.newTutorEmail.split('@')[0];
      } else {
        username = `${this.newTutorFirstName}.${this.newTutorLastName}`.toLowerCase();
      }
      const payload = {
        data: [
          {
            last_name: this.newTutorLastName,
            first_name: this.newTutorFirstName,
            email: this.newTutorEmail,
            email2: '',
            email3: '',
            username,
            ypareo_id: '',
            azure_id: '',
            enterprise: this.newTutorEnterprise || '',
            role: 'tuteur',
            cfa: cfaId,
            organization: orgId,
            training: this.newTutorAssociateToTraining && this.training
              ? this.training.id
              : undefined,
          },
        ],
      };
      this.startLoading();
      this.$http.post('/create_users/', payload)
        .then((response) => {
          const createdId = response.data && response.data.id;
          if (createdId && this.newTutorAssociateToTraining) {
            const tutorsToPatch = [...this.training.tutors, createdId];
            return this.$http.patch(`/trainings/${this.$route.params.idTraining}/`, {
              tutors: tutorsToPatch,
            }).then((res2) => {
              this.training = res2.data;
              this.tutorsList.push({ id: createdId, name: `${this.newTutorLastName} ${this.newTutorFirstName}` });
            });
          }
          if (createdId) {
            this.tutorsList.push({ id: createdId, name: `${this.newTutorLastName} ${this.newTutorFirstName}` });
          }
          return null;
        })
        .then(() => {
          this.$buefy.notification.open({
            message: 'Tuteur créé',
            type: 'is-success',
          });
          this.initTraining();
        })
        .catch(() => {
          this.$buefy.notification.open({
            message: 'Erreur lors de la création du tuteur',
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.endLoading();
          this.closeCreateTutorModal();
        });
    },
    gotoStep(numberStep) {
      this.currentTab = numberStep;
      this.step = numberStep;
      if (this.currentTab === 1) {
        window.console.log('hi');
      }
    },
    initTraining() {
      this.$http
        .get(`/trainings/${this.$route.params.idTraining}/?query={*,training_periods{*,training_sequences{-training_activities}}}&format=json`)
        .then((response) => {
          this.training = response.data;
          this.teachersEdit = this.training.teachers_can_edit;
          this.teachersList = response.data.teachers_list || [];
          this.studentsList = response.data.students_list || [];
          this.managersList = response.data.managers_list || [];
          this.tutorsList = response.data.tutors_list || [];
          this.endLoading();
        });
    },
    getTeacherNameById(id) {
      const entry = (this.teachersList || []).find((t) => t.id === id);
      return entry ? entry.name : '';
    },
    getStudentNameById(id) {
      const entry = (this.studentsList || []).find((s) => s.id === id);
      return entry ? entry.name : '';
    },
    getManagerNameById(id) {
      const entry = (this.managersList || []).find((m) => m.id === id);
      return entry ? entry.name : '';
    },
    getTutorNameById(id) {
      const entry = (this.tutorsList || []).find((t) => t.id === id);
      return entry ? entry.name : '';
    },
    forceRerender() {
      this.componentKey += 1;
    },
    setAvailableTeachers() {
      // get available teachers
      // will need to add an organization limitation
      this.$http
        .get(`/get_profiles/?search=${this.search}&role=formateur&items=4000&format=json`)
        .then((response) => {
          this.totalTeachers = response.data.count;
          const teachersToDisplay = response.data.results;
          // for each item of avalable teachers remove teachers already selected
          for (let i = 0; i < this.training.teachers.length; i += 1) {
            const alreadyAdded = _.findKey(teachersToDisplay,
              (e) => e.id === this.training.teachers[i]);
            if (alreadyAdded) {
              teachersToDisplay.splice(alreadyAdded, 1);
            }
          }
          this.availableteachers = teachersToDisplay;
          this.endLoading();
        });
    },
    setAvailableStudents() {
      // get available teachers
      this.$http
        .get(`/get_profiles/?search=${this.search}&role=apprenant&items=4000&format=json`)
        .then((response) => {
          const studentsToDisplay = response.data.results;
          this.totalStudents = response.data.count;

          // for each item of avalable teachers remove teachers already selected
          for (let i = 0; i < this.training.students.length; i += 1) {
            const alreadyAdded = _.findKey(response.data.results,
              (e) => e.id === this.training.students[i]);
            if (alreadyAdded) {
              studentsToDisplay.splice(alreadyAdded, 1);
            }
          }
          this.availablestudents = studentsToDisplay;
          this.endLoading();
        });
    },
    setAvailableManagers() {
      // get available managers
      // will need to add an organization limitation
      this.$http
        .get(`/get_profiles/?search=${this.search}&role=manager&items=4000&format=json`)
        .then((response) => {
          const managersToDisplay = response.data.results;
          this.totalManagers = response.data.count;
          this.availablemanagers = response.data.results;
          // for each item of avalable teachers remove teachers already selected
          for (let i = 0; i < this.training.managers.length; i += 1) {
            const alreadyAdded = _.findKey(response.data.results,
              (e) => e.id === this.training.managers[i]);
            if (alreadyAdded) {
              managersToDisplay.splice(alreadyAdded, 1);
            }
          }
          this.availablemanagers = managersToDisplay;
          this.endLoading();
        });
    },
    setAvailableTutors() {
      // get available teachers
      // will need to add an organization limitation
      this.$http
        .get(`/get_profiles/?search=${this.search}&role=tuteur&items=4000&format=json`)
        .then((response) => {
          const tutorsToDisplay = response.data.results;
          this.totalTutors = response.data.count;
          this.availabletutors = response.data.results;

          // for each item of avalable teachers remove teachers already selected
          for (let i = 0; i < this.training.tutors.length; i += 1) {
            const alreadyAdded = _.findKey(response.data.results,
              (e) => e.id === this.training.tutors[i]);
            if (alreadyAdded) {
              tutorsToDisplay.splice(alreadyAdded, 1);
            }
          }
          this.availabletutors = tutorsToDisplay;
          this.endLoading();
        });
    },
    addTeachers() {
      this.startLoading();
      const teacherToPatch = [];
      // patch training to relate users
      // add in teachers array items in training teachers
      this.teachers.forEach((teacher) => {
        teacherToPatch.push(teacher.id);
      });
      for (let i = 0; i < this.training.teachers.length; i += 1) {
        teacherToPatch.push(this.training.teachers[i]);
      }
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          teachers: teacherToPatch,
        })
        .then((response) => {
          this.teachers = [];
          this.training = response.data;
          this.endLoading();
          this.setAvailableTeachers();
        }).then(() => {
          this.$buefy.notification.open({ message: 'Formateurs ajoutés', type: 'is-success' });
        });
    },
    removeTeacher(teacher) {
      this.startLoading();
      // patch training to relate users
      // add in teachers array items in training teachers
      const removedteacher = this.training.teachers.indexOf(teacher);
      this.training.teachers.splice(removedteacher, 1);
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          teachers: this.training.teachers,
        })
        .then((response) => {
          this.training = response.data;
          this.setAvailableTeachers();
          this.endloading();
        })
        .then(() => {
          this.$buefy.notification.open({ message: 'Formateurs supprimés', type: 'is-success' });
        });
    },
    addStudents() {
      this.startLoading();
      const studentsToPatch = [];
      // patch training to relate users
      this.students.forEach((student) => {
        studentsToPatch.push(student.id);
      });
      this.training.students.forEach((student) => {
        studentsToPatch.push(student);
      });
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          students: studentsToPatch,
        })
        .then((response) => {
          this.students = [];
          this.training = response.data;
          this.setAvailableStudents();
          this.endLoading();
        }).then(() => {
          this.$buefy.notification.open({ message: 'Étudiants ajoutés', type: 'is-success' });
          this.createStudentTraining();
        });
    },
    removeStudent(student) {
      let studentTainingDeleted = null;
      this.$http
        .get(`/agenda/student_training/?training=${this.training.id}&student=${student}&query={id}&format=json`)
        .then((response1) => {
          studentTainingDeleted = response1.data[0].id;
          const removedStudent = this.training.students.indexOf(student);
          this.training.students.splice(removedStudent, 1);
          const studentTrainings = this.training.related_student_trainings_from_this_training;
          const removedStudentTraining = studentTrainings.indexOf(studentTainingDeleted);
          if (removedStudentTraining > -1) {
            this.training.related_student_trainings_from_this_training
              .splice(removedStudentTraining, 1);
          }
          this.$http
            .patch(`/trainings/${this.$route.params.idTraining}/`, {
              students: this.training.students,
              related_student_trainings_from_this_training:
                this.training.related_student_trainings_from_this_training,
            })
            .then((response) => {
              this.training = response.data;
              this.setAvailableStudents();
            })
            .then(() => {
              this.$buefy.notification.open({ message: 'Apprenants supprimés', type: 'is-success' });
            });
          this.$http
            .patch(`/agenda/student_training/${studentTainingDeleted}/`, {
              deleted: true,
            });
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    addManagers() {
      this.startLoading();
      const managersToPatch = [];
      // patch training to relate users
      this.managers.forEach((manager) => {
        managersToPatch.push(manager.id);
      });
      this.training.managers.forEach((manager) => {
        managersToPatch.push(manager);
      });
      // patch training to relate users
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          managers: managersToPatch,
        })
        .then((response) => {
          this.managers = [];
          this.training = response.data;
          this.setAvailableManagers();
          this.endLoading();
        }).then(() => {
          this.$buefy.notification.open({ message: 'Managers ajoutés', type: 'is-success' });
        });
    },
    removeManager(manager) {
      // patch training to relate users
      // add in teachers array items in training teachers
      const removedmanager = this.training.managers.indexOf(manager);
      this.training.managers.splice(removedmanager, 1);
      this.$http
        .patch(`trainings/${this.$route.params.idTraining}/`, {
          managers: this.training.managers,
        })
        .then((response) => {
          this.training = response.data;
          this.setAvailableManagers();
        })
        .then(() => {
          this.$buefy.notification.open({ message: 'Managers supprimés', type: 'is-success' });
        });
    },
    addTutors() {
      this.startLoading();
      const tutorsToPatch = [];
      this.tutors.forEach((tutor) => {
        tutorsToPatch.push(tutor.id);
      });
      this.training.tutors.forEach((tutor) => {
        tutorsToPatch.push(tutor);
      });
      // patch training to relate users
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          tutors: tutorsToPatch,
        })
        .then((response) => {
          this.tutors = [];
          this.training = response.data;
          this.setAvailableTutors();
          this.endLoading();
        }).then(() => {
          this.$buefy.notification.open({ message: 'Tuteurs ajoutés', type: 'is-success' });
        });
    },
    removeTutor(tutor) {
      // patch training to relate users
      // add in teachers array items in training teachers
      const removedtutor = this.training.tutors.indexOf(tutor);
      this.training.tutors.splice(removedtutor, 1);
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          tutors: this.training.tutors,
        })
        .then((response) => {
          this.training = response.data;
          this.setAvailableTutors();
        })
        .then(() => {
          this.$buefy.notification.open({ message: 'Tuteurs supprimés', type: 'is-success' });
        });
    },
    createStudentTraining() {
      this.$http
        .post('/agenda/students2studenttrainings/?format=json', {
          training_id: this.$route.params.idTraining,
          student_ids: this.training.students,
        });
    },
    startLoading() {
      this.isLoading = true;
    },
    endLoading() {
      this.isLoading = false;
    },
    teacherEdition() {
      this.$http
        .patch(`/trainings/${this.$route.params.idTraining}/`, {
          teachers_can_edit: this.training.teachers_can_edit,
        })
        .then(() => {
          this.$buefy.notification.open({ message: 'Droits modifiés', type: 'is-success' });
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    onPageTeacherChange(page) {
      this.pageTeacher = page;
      this.setAvailableTeachers();
    },
  },
  created() {
    this.initTraining();
  },
  mounted() {
  },
  props: {
    trainingObject: {
      type: [Object, Array],
    },
  },
  data() {
    return {
      // training: [],
      totalTeachers: [],
      totalTutors: [],
      totalStudents: [],
      totalManagers: [],
      isLoading: true,
      isFullPage: false,
      componentKey: 0,
      step: 1,
      currentTab: 1,
      students: [],
      managers: [],
      tutors: [],
      teachers: [],
      teachersArray: [],
      teachersEdit: false,
      tabs: [
        {
          name: 'Formateurs',
          id: '1',
        },
        {
          name: 'Apprenants',
          id: '2',
        },
        {
          name: 'Managers',
          id: '3',
        },
        {
          name: 'Tuteurs',
          id: '4',
        },
      ],
      usersColumns: [
        {
          field: 'user',
          label: 'Nom',
          width: '200',
          sortable: true,
          visible: true,
        },
        // {
        //   field: 'organization',
        //   label: 'Organisation',
        //   centered: true,
        //   sortable: true,
        //   visible: true,
        // },
        // {
        //   field: 'rights',
        //   label: 'Droits',
        //   centered: true,
        //   sortable: true,
        //   visible: true,
        // },
        {
          field: 'delete',
          label: 'Supprimer',
          numeric: true,
          centered: true,
          sortable: true,
          visible: true,
        },
      ],
      vailableUsersColumns: [
        {
          field: 'user',
          label: 'Nom',
          width: '200',
          sortable: true,
          visible: true,
        },
        // {
        //   field: 'organization',
        //   label: 'Organisation',
        //   centered: true,
        //   sortable: true,
        //   visible: true,
        // },
        // {
        //   field: 'delete',
        //   label: 'Supprimer',
        //   numeric: true,
        //   centered: true,
        //   sortable: true,
        //   visible: true,
        // },
      ],
      search: '',
      availableteachers: [],
      availablestudents: [],
      availabletutors: [],
      availablemanagers: [],
      perPage: 10,
      training: [],
      teachersList: [],
      studentsList: [],
      managersList: [],
      tutorsList: [],
      newTeacherModalActive: false,
      newTeacherLastName: '',
      newTeacherFirstName: '',
      newTeacherEmail: '',
      newTeacherIdentifier: '',
      newTeacherAssociateToTraining: true,
      newStudentModalActive: false,
      newStudentLastName: '',
      newStudentFirstName: '',
      newStudentEmail: '',
      newStudentIdentifier: '',
      newStudentAssociateToTraining: true,
      newStudentEnterprise: '',
      newManagerModalActive: false,
      newManagerLastName: '',
      newManagerFirstName: '',
      newManagerEmail: '',
      newManagerIdentifier: '',
      newManagerAssociateToTraining: true,
      newManagerEnterprise: '',
      newTutorModalActive: false,
      newTutorLastName: '',
      newTutorFirstName: '',
      newTutorEmail: '',
      newTutorIdentifier: '',
      newTutorAssociateToTraining: true,
      importModalActive: false,
      importFile: null,
      importError: null,
      importInProgress: false,
      newTutorEnterprise: '',
    };
  },
};
</script>
<style scoped>
.table td {
  padding: 0.5em 0.7em !important;
}
</style>
